import React, { createContext, useState, useEffect, useContext, useCallback } from 'react';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // Vérifier l'authentification au chargement
  useEffect(() => {
    checkAuth();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const checkAuth = () => {
    try {
      // Vérifier le token dans localStorage (utiliser les mêmes clés que le reste de l'app)
      const token = localStorage.getItem('admin_token');
      const userData = localStorage.getItem('admin_user');

      if (token && userData) {
        // Vérifier si le token est expiré
        const tokenExpiry = localStorage.getItem('tokenExpiry');
        const now = new Date().getTime();

        if (tokenExpiry && now > parseInt(tokenExpiry)) {
          // Token expiré - déconnecter
          logout();
        } else {
          // Token valide
          setUser(JSON.parse(userData));
          setIsAuthenticated(true);
        }
      } else {
        setIsAuthenticated(false);
        setUser(null);
      }
    } catch (error) {
      console.error('Erreur lors de la vérification de l\'authentification:', error);
      setIsAuthenticated(false);
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  const login = (userData, token, expiresIn = 24 * 60 * 60 * 1000) => {
    // Sauvegarder les données d'authentification (utiliser les mêmes clés que le reste de l'app)
    localStorage.setItem('admin_token', token);
    localStorage.setItem('admin_user', JSON.stringify(userData));
    
    // Définir l'expiration du token (par défaut 24h)
    const expiryTime = new Date().getTime() + expiresIn;
    localStorage.setItem('tokenExpiry', expiryTime.toString());

    setUser(userData);
    setIsAuthenticated(true);
  };

  const logout = () => {
    // Supprimer toutes les données d'authentification
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_user');
    localStorage.removeItem('tokenExpiry');
    
    setUser(null);
    setIsAuthenticated(false);
  };

  const updateUser = (userData) => {
    localStorage.setItem('admin_user', JSON.stringify(userData));
    setUser(userData);
  };

  const value = {
    user,
    isAuthenticated,
    loading,
    login,
    logout,
    updateUser,
    checkAuth
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

// Hook personnalisé pour utiliser le contexte
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth doit être utilisé à l\'intérieur d\'un AuthProvider');
  }
  return context;
};

export default AuthContext;
